import angular from 'angular';
import moment from 'moment';
import { Empresa, Estabelecimento } from '../../../../../core/usuario/models/usuario-model';
import { ListagemService } from '../../../../../shared/services/listagem.service';
import { IAjustePonto, AjustePontoSituacao } from '../models/ajusteponto.model';
import { AjustesPontoService } from '../ajustesponto.service';
import { MotivoRecusaModalService } from '../modal/motivo-recusa.modal.service';
import { IApuracaoFilter, IApuracaoPonto, IApuracaoSelectItem } from '../../models/apuracaoponto.model';
import { ApuracoesPontoService } from '../../ApuracoesPonto/apuracoesponto.service';
import { MeurhVisualizarmodalService } from '../../../Anexos/visualizarmodal/anexos.visualizarmodal.service';
import { applyNsjTableInlineMobileLabels } from '../../../../../utils/nsj-table';

type IAjustesPontoFilters = {
    empresa?: string;
    estabelecimento?: string;
    lotacao?: {
        lotacao: string;
    } | null;
    departamento?: {
        departamento: string;
    } | null;
    situacao?: AjustePontoSituacao;
    apuracao?: IApuracaoFilter | null;
    tipoajuste?: {
        id: string;
        origem: string;
        tipo: string;
        nome: string;
    } | null;
    grupoponto?: {
        grupo: string;
        nome?: string;
        descricao?: string;
    } | null;
};

type IAjustesPontoOrdenacao = {
    campo: 'dataajustada' | 'data_mudanca_estado';
    direcao: 'asc' | 'desc';
};

const TIPOS_AJUSTE = [
    { id: 'ajuste_marcacao_incluir', origem: 'ajuste_marcacao', tipo: 'incluir', nome: 'Incluir marcação' },
    { id: 'ajuste_marcacao_alterar', origem: 'ajuste_marcacao', tipo: 'alterar', nome: 'Alterar marcação' },
    { id: 'ajuste_marcacao_ignorar', origem: 'ajuste_marcacao', tipo: 'ignorar', nome: 'Ignorar marcação' },
    // 110540: ajuste de pausa (NR17) é origem própria na ponto.vwgestaopendenciasponto.
    { id: 'ajuste_pausa_incluir', origem: 'ajuste_pausa', tipo: 'incluir', nome: 'Incluir pausa' },
    { id: 'ajuste_pausa_alterar', origem: 'ajuste_pausa', tipo: 'alterar', nome: 'Alterar pausa' },
    { id: 'ajuste_pausa_ignorar', origem: 'ajuste_pausa', tipo: 'ignorar', nome: 'Ignorar pausa' },
    // 110093: atraso justificado deixou de exigir ajuste, então virou origem própria na
    // ponto.vwgestaopendenciasponto ('atraso_marcacao'), e não um tipo de ajuste_marcacao.
    { id: 'atraso_marcacao_atraso', origem: 'atraso_marcacao', tipo: 'atraso', nome: 'Atraso justificado' },
    { id: 'atestado_atestado', origem: 'atestado', tipo: 'atestado', nome: 'Atestado' },
    { id: 'atestado_horas_atestado_horas', origem: 'atestado_horas', nome: 'Atestado horas' },
    { id: 'falta', origem: 'falta', nome: 'Falta' },
    { id: 'folga_folga', origem: 'folga', nome: 'Folga' },
];

export class AjustesPontoIndexController {
    static $inject = ['$scope', '$rootScope', 'ListagemService', 'AjustesPontoService', 'ApuracoesPontoService', 'NewToaster', 'MotivoRecusaModalService', 'MeurhVisualizarmodalService'];

    public entities: IAjustePonto[] = [];
    public searchTerm = '';
    public checkboxPreenchidos: IAjustePonto[] = [];
    public fields: Array<any> = [];
    public busy = false;
    public aprovacaoLoteBusy = false;
    public recusaLoteBusy = false;
    public exportacaoBusy = false;
    public filterActive = false;
    public filters: IAjustesPontoFilters = {};
    public ordenacao: IAjustesPontoOrdenacao | null = null;
    public empresas: Array<Empresa> = [];
    public estabelecimentos: Array<Estabelecimento> = [];
    public listagemPermissao: Array<string> = [];
    public permissaoGrupoEmpresarial = true;
    public entityService: AjustesPontoService;

    public activeTabIndex = 0;
    public situacoesAjustes: Array<{ label: string; value: AjustePontoSituacao }> = [
        { label: 'Pendentes', value: AjustePontoSituacao.Pendente },
        { label: 'Aprovados', value: AjustePontoSituacao.Aprovado },
        { label: 'Recusados', value: AjustePontoSituacao.Recusado }
    ];
    public apuracoes: Array<IApuracaoPonto> = [];
    public apuracoesSelect: IApuracaoSelectItem[] = [];
    public tiposAjuste: Array<{ id: string; origem: string; tipo?: string; nome: string }> = [];
    public totalPendente = 0;


    private baseFields: Array<any> = [];
    private actionsField: any = null;
    private fotoCache = new Map<string, string>();
    private fotoLoading = new Set<string>();
    private readonly situacaoLabels: Record<AjustePontoSituacao, string> = {
        [AjustePontoSituacao.Pendente]: 'Pendente',
        [AjustePontoSituacao.Aprovado]: 'Aprovado',
        [AjustePontoSituacao.Recusado]: 'Recusado'
    };

    constructor(
        private $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            temPermissaoGrupoEmpresarial?: (permissoes: string[], grupo: string) => boolean;
            nsjGlobals?: any;
            session?: any;
        },
        public ListagemService: ListagemService,
        public AjustesPontoService: AjustesPontoService,
        public ApuracoesPontoService: ApuracoesPontoService,
        public NewToaster: { pop: (opts: { type: string; title: string; body?: string }) => void },
        public MotivoRecusaModalService: MotivoRecusaModalService,
        public MeurhVisualizarmodalService: MeurhVisualizarmodalService,
    ) {
        this.entityService = this.AjustesPontoService;
        this.entities = this.entityService.entities;
        this.searchTerm = this.entityService.filter || '';
        this.entityService.filter = '';

        this.$scope.$on('ajustesponto_list_loading', () => {
            this.busy = true;
        });

        this.$scope.$on('ajustesponto_list_finished', () => {
            this.decorateEntities();
            this.applySearchFilter();
            this.busy = false;
        });

        this.$scope.$on('ajustesponto_list_error', (_event, error?: any) => {
            this.entities = [];
            this.busy = false;
            this.checkboxPreenchidos = [];
            if (this.filters?.situacao === AjustePontoSituacao.Pendente) {
                this.totalPendente = 0;
            }

            this.NewToaster.pop({
                type: 'error',
                title: 'Erro ao carregar ajustes de ponto',
                body: error?.data?.message || 'Ocorreu um erro ao carregar os ajustes. Tente novamente.'
            });
        });

        this.$scope.$on('apuracoesponto_index_loaded', () => {
            if (this.ApuracoesPontoService.loadParams.finished ||
                this.ApuracoesPontoService.loadParams.to_load === 0
            ) {
                this.montaApuracaoSelect();
            }
        });

        this.busy = true;
        this.carregaApuracoes();

        this.initializeListagem();
        this.applySearchFilter();
        this.carregarFiltrosMock();

        this.baseFields = applyNsjTableInlineMobileLabels([
            {
                value: 'trabalhadorDisplay',
                label: 'Colaborador',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnScope: {
                    resolveFoto: (entity: IAjustePonto) => {
                        return this.resolveColaboradorFoto(entity);
                    }
                },
                customCollumnHtml: () => {
                    return `
                        <div class="ajustesponto-colaborador" ng-init="customCollumnScope.resolveFoto(tableRowEntity)">
                            <img
                                class="ajustesponto-colaborador__foto"
                                ng-if="tableRowEntity.colaboradorFotoUrl"
                                ng-src="{{tableRowEntity.colaboradorFotoUrl}}"
                                alt=""
                                aria-hidden="true"
                            />
                            <span class="ajustesponto-colaborador__nome">
                                {{tableRowEntity.trabalhadorDisplay || '-'}}
                            </span>
                        </div>
                    `;
                }
            },
            {
                value: 'matricula',
                label: 'Matrícula',
                type: 'string',
                style: 'title',
                copy: '',
            },
            {
                value: 'dataAjustadaDisplay',
                label: 'Data ajustada',
                type: 'string',
                style: 'title',
                copy: '',
            },
            {
                value: 'tipo',
                label: 'Tipo',
                type: 'string',
                style: 'title',
                copy: '',
            },
            {
                value: 'detalhesDisplay',
                label: 'Detalhes',
                type: 'string',
                style: 'title',
                copy: '',
                customCollumnHtml: () => {
                    return `
                        <div class="ajuste-detalhes">
                            <div class="ajuste-detalhes__horario" ng-if="tableRowEntity.horarioNovo || tableRowEntity.horarioAntigo">
                                <span ng-if="tableRowEntity.horarioLabel">
                                    {{tableRowEntity.horarioLabel}}:
                                </span>
                                <span ng-if="tableRowEntity.horarioAntigo">
                                    {{tableRowEntity.horarioAntigo}}
                                </span>
                                <span class="ajuste-detalhes__horario-separador"
                                    ng-if="tableRowEntity.horarioAntigo && tableRowEntity.horarioNovo">
                                    &rarr;
                                </span>
                                <strong ng-if="tableRowEntity.horarioNovo">
                                    {{tableRowEntity.horarioNovo}}
                                </strong>
                            </div>
                            <div class="ajuste-detalhes__justificativa" ng-if="tableRowEntity.justificativa">
                                {{tableRowEntity.justificativa}}
                            </div>
                            <div class="ajuste-detalhes__motivo" ng-if="tableRowEntity.detalhesMotivo">
                                Motivo: {{tableRowEntity.detalhesMotivo}}
                            </div>
                            <div class="ajuste-detalhes__anexo" ng-if="tableRowEntity.temAnexo">
                                <a ng-click="customCollumnScope.visualizarAnexo(tableRowEntity)">
                                    <i class="fas fa-paperclip"></i> Visualizar anexo
                                </a>
                            </div>
                            <div class="ajuste-detalhes__status" ng-if="tableRowEntity.historicoStatusExibicao">
                                {{tableRowEntity.historicoStatusExibicao}}
                            </div>
                        </div>
                    `;
                },
                customCollumnScope: {
                    visualizarAnexo: (entity: IAjustePonto) => {
                        const url = this.AjustesPontoService.getAnexoUrl(entity);
                        if (url) {
                            this.busy = true;
                            this.AjustesPontoService.getAnexoBlob(url)
                                .then((response: { data: ArrayBuffer, contentType: string }) => {
                                    const blob = new Blob([response.data], { type: response.contentType });
                                    const entityModal = {
                                        file: blob,
                                        type: response.contentType
                                    };
                                    this.MeurhVisualizarmodalService.open(entityModal, 'show');
                                })
                                .catch(() => {
                                    this.NewToaster.pop({
                                        type: 'error',
                                        title: 'Erro ao visualizar anexo',
                                        body: 'Não foi possível carregar o arquivo.'
                                    });
                                })
                                .finally(() => {
                                    this.busy = false;
                                });
                        }
                    }
                }
            }
        ]);
        this.actionsField = {
            value: 'gestaoponto',
            label: 'Ações',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnScope: {
                aprovarAjuste: (entity: IAjustePonto) => {
                    this.aprovarAjuste(entity);
                },
                recusarAjuste: (entity: IAjustePonto) => {
                    this.recusarAjuste(entity);
                },
                podeAprovar: (entity: IAjustePonto) => {
                    return this.podeAprovar(entity);
                },
                podeRecusar: (entity: IAjustePonto) => {
                    return this.podeRecusar(entity);
                },
                temSelecaoAtiva: () => {
                    return this.temSelecaoAtiva();
                }
            },
            customCollumnHtml: () => {
                const actionsHtml = `
                    <div class="ajustesponto-acoes">
                        <a
                            class="ajustesponto-acoes__btn ajustesponto-acoes__btn--aprovar"
                            ng-click="customCollumnScope.aprovarAjuste(tableRowEntity)"
                            ng-disabled="!customCollumnScope.podeAprovar(tableRowEntity) || customCollumnScope.temSelecaoAtiva()"
                            ng-class="{'ajustesponto-acoes__btn--disabled': !customCollumnScope.podeAprovar(tableRowEntity) || customCollumnScope.temSelecaoAtiva()}"
                            uib-tooltip="Aprovar ajuste"
                            tooltip-placement="top"
                            tooltip-append-to-body="true"
                            aria-label="Aprovar ajuste"
                        >
                            <i class="fas fa-check"></i>
                        </a>
                        <a
                            class="ajustesponto-acoes__btn ajustesponto-acoes__btn--recusar"
                            ng-click="customCollumnScope.recusarAjuste(tableRowEntity)"
                            ng-disabled="!customCollumnScope.podeRecusar(tableRowEntity) || customCollumnScope.temSelecaoAtiva()"
                            ng-class="{'ajustesponto-acoes__btn--disabled': !customCollumnScope.podeRecusar(tableRowEntity) || customCollumnScope.temSelecaoAtiva()}"
                            uib-tooltip="Recusar ajuste"
                            tooltip-placement="top"
                            tooltip-append-to-body="true"
                            aria-label="Recusar ajuste"
                        >
                            <i class="fas fa-times"></i>
                        </a>
                    </div>
                `;
                return actionsHtml;
            }
        };
        this.updateFieldsForSituacao();

        this.$scope.$on('$destroy', () => {
            this.onDestroy();
        });
    }

    carregaApuracoes(): void {
        this.ApuracoesPontoService.constructors['vigente'] = false;
        this.ApuracoesPontoService.constructors['empresa'] = this.$rootScope.session?.entities?.empresa?.empresa;
        this.ApuracoesPontoService.constructors['estabelecimento'] = '';
        this.apuracoes = this.ApuracoesPontoService.reload();
    }

    montaApuracaoSelect(): void {
        this.apuracoesSelect = this.apuracoes.map((element) => {
            const { nome: nomeReferencia, referencia } = this.getReferenciaApuracao(element);
            return {
                periodo: `
                    ${moment(element.inicioapuracao).format('DD/MM/YYYY')} a
                    ${moment(element.terminoapuracao).format('DD/MM/YYYY')} ${nomeReferencia}`,
                inicioapuracao: element.inicioapuracao,
                terminoapuracao: element.terminoapuracao,
                apuracaoponto: element.apuracaoponto,
                referencia
            };
        });
        this.setFilterApuracao();
        this.filterApuracao();
    }

    getReferenciaApuracao(apuracao: IApuracaoPonto) {
        if (apuracao.trabalhadorobj?.trabalhador) {
            return {
                nome: `- Trabalhador: ${apuracao.trabalhadorobj.nome}`,
                referencia: apuracao.trabalhadorobj
            };
        }
        if (apuracao.lotacaoobj?.lotacao) {
            return {
                nome: `- Lotação: ${apuracao.lotacaoobj.nome} `,
                referencia: apuracao.lotacaoobj
            };
        }
        if (apuracao.estabelecimentoobj?.estabelecimento) {
            return {
                nome: `- Estabelecimento: ${apuracao.estabelecimentoobj.nomefantasia}`,
                referencia: apuracao.estabelecimentoobj
            };
        }
        if (apuracao.empresaobj?.empresa) {
            return {
                nome: `- Empresa: ${apuracao.empresaobj.razaosocial}`,
                referencia: apuracao.empresaobj
            };
        }
        return {
            nome: '',
            referencia: null
        };
    }

    setFilterApuracao(): void {
        if (!this.apuracoesSelect.length || this.filters.apuracao) {
            return;
        }

        const dataAtual = moment();
        const apuracaoAtual = this.apuracoesSelect.find((apuracao) => {
            const inicioApuracao = moment(apuracao.inicioapuracao, 'YYYY-MM-DD');
            const terminoApuracao = moment(apuracao.terminoapuracao, 'YYYY-MM-DD');
            return dataAtual.isBetween(inicioApuracao, terminoApuracao, undefined, '[]')
                && apuracao.referencia && ('empresa' in apuracao.referencia);
        });

        if (apuracaoAtual) {
            this.filters.apuracao = apuracaoAtual;
            return;
        }

        this.filters.apuracao = this.apuracoesSelect[0];
    }

    filterApuracao(): void {
        const apuracao = this.filters.apuracao;
        if (!apuracao) {
            this.busy = false;
            return;
        }

        const filtersToReset = ['lotacao', 'departamento'];
        filtersToReset.forEach((key) => (this.filters as any)[key] = null);

        let empresa = this.$rootScope?.session?.entities?.empresa?.empresa || '';
        let estabelecimento = '';

        const referencia = apuracao.referencia;
        if (referencia) {
            if ('empresa' in referencia) {
                empresa = referencia.empresa;
            } else if ('estabelecimento' in referencia) {
                estabelecimento = referencia.estabelecimento;
            } else if ('lotacao' in referencia) {
                this.filters.lotacao = referencia;
            }
        }

        this.filters.empresa = empresa;
        this.filters.estabelecimento = estabelecimento;
        this.estabelecimentos = this.filters.empresa
            ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao)
            : [];

        this.$rootScope.$broadcast('lotacao_refresh', this.constructorEmpresaEstabelecimento());
        this.$rootScope.$broadcast('departamento_refresh', this.constructorEmpresaEstabelecimento());

        this.filterReload();
    }

    initializeListagem(): void {
        const grupoEmpresarial = this.$rootScope?.nsjGlobals?.a?.grupoempresarial;

        this.permissaoGrupoEmpresarial = this.canVisualizarTodasEmpresas(grupoEmpresarial);

        if (grupoEmpresarial) {
            this.empresas = this.ListagemService.montaEmpresas(grupoEmpresarial, this.listagemPermissao);
        }

        const empresaPadrao = this.$rootScope?.session?.entities?.empresa?.empresa;
        const estabelecimentoPadrao = this.$rootScope?.session?.entities?.estabelecimento?.estabelecimento;

        const filtrosIniciais: IAjustesPontoFilters = {
            ...this.filters
        };

        if (!filtrosIniciais.situacao) {
            filtrosIniciais.situacao = AjustePontoSituacao.Pendente;
        }

        if (empresaPadrao) {
            filtrosIniciais.empresa = empresaPadrao;
        }

        if (estabelecimentoPadrao) {
            filtrosIniciais.estabelecimento = estabelecimentoPadrao;
        }

        this.filters = filtrosIniciais;
        this.activeTabIndex = this.resolveActiveTabIndex(this.filters.situacao);

        if (this.filters.empresa) {
            this.estabelecimentos = this.ListagemService.montaEstabelecimentos(
                this.filters.empresa,
                this.empresas,
                this.listagemPermissao
            );
        }
    }

    public mudaEstabelecimentos(): void {
        this.estabelecimentos = this.filters.empresa
            ? this.ListagemService.montaEstabelecimentos(this.filters.empresa, this.empresas, this.listagemPermissao)
            : [];

        this.filters.estabelecimento = '';
        this.filtraEmpresaEstabelecimento();
    }

    public filtraEmpresaEstabelecimento(): void {
        if (this.filters.lotacao) {
            delete this.filters.lotacao;
        }

        if (this.filters.departamento) {
            delete this.filters.departamento;
        }

        this.$rootScope.$broadcast('lotacao_refresh', this.constructorEmpresaEstabelecimento());
        this.filterReload();
    }

    public constructorEmpresaEstabelecimento() {
        return {
            empresa: this.filters.empresa,
            estabelecimento: this.filters.estabelecimento
        };
    }

    public filterReload(): void {
        this.updateFieldsForSituacao();
        const constructors = this.setConstructor();
        this.AjustesPontoService.constructors = angular.copy(constructors);
        this.AjustesPontoService.filters = angular.copy(constructors);
        this.checkboxPreenchidos = [];
        this.busy = true;

        this.entityService.reload();
    }

    public podeExportar(): boolean {
        return !this.busy && !this.exportacaoBusy && this.entities.length > 0;
    }

    /**
     * Exporta a aba visível no momento (pendentes, aprovados ou recusados),
     * usando os mesmos filtros já aplicados na listagem.
     */
    public exportar(): void {
        if (!this.podeExportar()) {
            return;
        }

        this.exportacaoBusy = true;

        this.AjustesPontoService.exportar(this.AjustesPontoService.constructors)
            .then((arquivo: Blob) => {
                this.baixarArquivo(arquivo);
            })
            .catch((error: any) => {
                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao exportar ajustes de ponto',
                    body: error?.status === 403
                        ? 'Você não tem permissão para exportar esses ajustes.'
                        : 'Não foi possível gerar a planilha. Tente novamente.'
                });
            })
            .finally(() => {
                this.exportacaoBusy = false;
            });
    }

    public search(): void {
        this.applySearchFilter();
    }

    public applySearchFilter(): void {
        const normalizedTerm = this.normalizeSearchValue(this.searchTerm);
        const baseEntities = this.entityService.entities || [];
        let filtered: IAjustePonto[] = [];

        if (!normalizedTerm) {
            filtered = baseEntities.slice();
        } else {
            filtered = baseEntities.filter((ajuste) => this.matchesSearch(ajuste, normalizedTerm));
        }

        this.entities = this.applyOrdenacao(filtered);
        this.syncCheckboxSelections();
    }

    matchesSearch(ajuste: IAjustePonto, normalizedTerm: string): boolean {
        if (!ajuste) {
            return false;
        }

        const nome = this.normalizeSearchValue(
            ajuste.trabalhadorDisplay || (ajuste.trabalhador && ajuste.trabalhador.nome)
        );
        const matricula = this.normalizeSearchValue(
            ajuste.matricula || (ajuste.trabalhador && ajuste.trabalhador.codigo)
        );

        return nome.includes(normalizedTerm) || matricula.includes(normalizedTerm);
    }

    normalizeSearchValue(value: string | number | null | undefined): string {
        if (value === null || value === undefined) {
            return '';
        }

        const text = value.toString().toLowerCase().trim();

        if (typeof text.normalize === 'function') {
            return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        }

        return text;
    }

    public setConstructor() {
        const params: Record<string, any> = {};

        if (this.filters.situacao) {
            params.status = this.filters.situacao.toLowerCase();
        }

        if (this.filters.empresa) {
            params['empresa'] = this.filters.empresa;
        }

        if (this.filters.estabelecimento) {
            params['estabelecimento'] = this.filters.estabelecimento;
        }

        if (this.filters.lotacao?.lotacao) {
            params['lotacao'] = this.filters.lotacao.lotacao;
        }

        if (this.filters.departamento?.departamento) {
            params['departamento'] = this.filters.departamento.departamento;
        }

        if (this.filters.apuracao?.apuracaoponto) {
            params.apuracaoponto = this.filters.apuracao.apuracaoponto;

            const apuracaoFilter = this.filters.apuracao as IApuracaoSelectItem;
            const inicio = apuracaoFilter.inicioapuracao;
            const termino = apuracaoFilter.terminoapuracao;

            if (inicio) {
                params['datareferencia[0][condition]'] = 'gte';
                params['datareferencia[0][value]'] = inicio;
            }

            if (termino) {
                params['datareferencia[1][condition]'] = 'lte';
                params['datareferencia[1][value]'] = termino;
            }
        }

        if (this.filters.tipoajuste?.origem) {
            params.origem = this.filters.tipoajuste.origem;
        }

        if (this.filters.tipoajuste?.tipo) {
            params.tipo = this.filters.tipoajuste.tipo;
        }

        if (this.filters.grupoponto?.grupo) {
            params.grupo = this.filters.grupoponto.grupo;
        }

        return params;
    }

    public carregarFiltrosMock(): void {
        this.tiposAjuste = TIPOS_AJUSTE.slice().sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
    }

    public syncCheckboxSelections(): void {
        if (!this.checkboxPreenchidos.length) {
            return;
        }

        const entidadesPorId = new Map(
            this.entities
                .filter((ajuste) => ajuste.id || ajuste.gestaoponto)
                .map((ajuste) => [
                    (ajuste.id || ajuste.gestaoponto || '').toString(),
                    ajuste
                ] as const)
        );

        const selecionadosAtualizados: IAjustePonto[] = [];
        const idsInseridos = new Set<string>();

        this.checkboxPreenchidos.forEach((ajuste) => {
            const ajusteChave = (ajuste.id || ajuste.gestaoponto || '').toString();

            if (!ajusteChave) {
                return;
            }

            const entidadeAtualizada = entidadesPorId.get(ajusteChave);

            if (entidadeAtualizada) {
                const chave = (entidadeAtualizada.id || entidadeAtualizada.gestaoponto || '').toString();

                if (chave && !idsInseridos.has(chave)) {
                    selecionadosAtualizados.push(entidadeAtualizada);
                    idsInseridos.add(chave);
                }
            }
        });

        this.checkboxPreenchidos = selecionadosAtualizados;
    }

    public loadMore(): void {
        if (this.hasSearchActive()) {
            return;
        }

        if (this.entityService.loadParams.busy || this.entityService.loadParams.finished) {
            return;
        }

        this.entityService.loadMore();
    }



    public decorateEntities(): void {
        let totalPendente = 0;

        this.entityService.entities.forEach((ajuste) => {
            if (!ajuste.id && ajuste.gestaoponto) {
                ajuste.id = ajuste.gestaoponto;
            }
            if (ajuste.detalhesDisplay === undefined || ajuste.detalhesDisplay === null) {
                ajuste.detalhesDisplay = '';
            }
            ajuste.matricula = this.resolveMatricula(ajuste.trabalhador);
            ajuste.trabalhadorDisplay = this.resolveTrabalhadorDisplay(ajuste.trabalhador);
            this.resolveColaboradorFoto(ajuste);
            ajuste.dataAjustadaDisplay = this.resolveDataDisplay(ajuste.dataajustada);
            this.resolveDetalhes(ajuste);
            ajuste.tipo = ajuste.tipo_exibicao || ajuste.tipo || '';
            this.definirSituacao(ajuste);

            if (this.isPendente(ajuste)) {
                totalPendente += 1;
            }
        });

        if (this.filters?.situacao === AjustePontoSituacao.Pendente) {
            this.totalPendente = totalPendente;
        }
    }

    public resolveMatricula(trabalhador: IAjustePonto['trabalhador']): string {
        if (!trabalhador) {
            return '';
        }

        return trabalhador.codigo || '';
    }

    public resolveTrabalhadorDisplay(trabalhador: IAjustePonto['trabalhador']): string {
        if (!trabalhador) {
            return '-';
        }

        return trabalhador.nome;
    }

    public resolveColaboradorFoto(ajuste: IAjustePonto): string {
        const trabalhadorId = ajuste?.trabalhador?.trabalhador;
        if (!trabalhadorId) {
            return '';
        }
        const cached = this.fotoCache.get(trabalhadorId);

        if (cached) {
            ajuste.colaboradorFotoUrl = cached;
            this.applyFotoToTrabalhador(trabalhadorId, cached);
            return cached;
        }
        if (this.fotoLoading.has(trabalhadorId)) {
            return '';
        }

        this.fotoLoading.add(trabalhadorId);
        this.AjustesPontoService.getTrabalhadorFoto(trabalhadorId)
            .then((url: string) => {
                if (!url) {
                    return;
                }
                this.fotoCache.set(trabalhadorId, url);
                ajuste.colaboradorFotoUrl = url;
                this.applyFotoToTrabalhador(trabalhadorId, url);
            })
            .catch(() => {
                // sem foto
            })
            .finally(() => {
                this.fotoLoading.delete(trabalhadorId);
            });

        return '';
    }

    applyFotoToTrabalhador(trabalhadorId: string, url: string): void {
        this.entityService.entities
            .filter((item) => item?.trabalhador?.trabalhador === trabalhadorId)
            .forEach((item) => {
                item.colaboradorFotoUrl = url;
            });
    }

    public resolveDataDisplay(data: string | null | undefined): string {
        if (!data) {
            return '-';
        }

        if (typeof data === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
            return data;
        }

        const parsed = moment.parseZone(data);

        if (!parsed.isValid()) {
            return '-';
        }

        return parsed.format('DD/MM/YYYY');
    }

    public definirOrdenacao(campo: IAjustesPontoOrdenacao['campo'], direcao: IAjustesPontoOrdenacao['direcao']): void {
        this.ordenacao = { campo, direcao };
        this.applySearchFilter();
    }

    public limparOrdenacao(): void {
        this.ordenacao = null;
        this.applySearchFilter();
    }

    public isOrdenacaoAtiva(campo: IAjustesPontoOrdenacao['campo'], direcao: IAjustesPontoOrdenacao['direcao']): boolean {
        return this.ordenacao?.campo === campo && this.ordenacao?.direcao === direcao;
    }

    public definirSituacao(ajuste: IAjustePonto): void {
        const situacao = this.resolveSituacaoValue(ajuste.status) || AjustePontoSituacao.Pendente;
        const labelFallback = (ajuste.status as string) || situacao;
        ajuste.situacaoLabel = this.situacaoLabels[situacao] || labelFallback;
        ajuste.situacaoClasse = this.getSituacaoClasse(situacao);
    }

    public getSituacaoClasse(situacao: string): string {
        switch (situacao) {
            case AjustePontoSituacao.Aprovado:
                return 'situacao-chip--success';
            case AjustePontoSituacao.Recusado:
                return 'situacao-chip--danger';
            case AjustePontoSituacao.Pendente:
            default:
                return 'situacao-chip--warning';
        }
    }



    public canVisualizarTodasEmpresas(grupo?: string): boolean {
        if (!this.listagemPermissao.length) {
            return true;
        }

        if (!grupo || typeof this.$rootScope.temPermissaoGrupoEmpresarial !== 'function') {
            return false;
        }

        return this.$rootScope.temPermissaoGrupoEmpresarial(this.listagemPermissao, grupo);
    }

    // --- Seleção ---

    public checar_todos(): void {
        if (!this.temTodosMarcados()) {
            const selectable = this.entities.filter((ajuste) => !ajuste.disableCheckbox);
            this.checkboxPreenchidos = angular.copy(selectable);
        } else {
            this.checkboxPreenchidos = [];
        }
    }

    public temTodosMarcados(): boolean {
        const totalSelecionaveis = this.entities.filter((ajuste) => !ajuste.disableCheckbox).length;
        return !!totalSelecionaveis && this.checkboxPreenchidos.length === totalSelecionaveis;
    }

    public naoTemTodosMarcados(): boolean {
        return !!this.checkboxPreenchidos.length && !this.temTodosMarcados();
    }

    public temSelecaoAtiva(): boolean {
        return this.checkboxPreenchidos.length > 0;
    }

    public getRowCustomClass(ajuste: IAjustePonto): string {
        return ajuste.rowcustomclass || '';
    }

    // --- Ações individuais ---

    public podeAprovar(ajuste: IAjustePonto): boolean {
        return this.isPendente(ajuste);
    }

    public podeRecusar(ajuste: IAjustePonto): boolean {
        return this.isPendente(ajuste);
    }

    public aprovarAjuste(ajuste: IAjustePonto): void {
        if (!ajuste?.gestaoponto) {
            console.error('Ajuste sem ID');
            return;
        }

        if (!this.podeAprovar(ajuste)) {
            return;
        }

        this.busy = true;

        this.AjustesPontoService.aprovarAjuste(ajuste.gestaoponto)
            .then((response: any) => {
                if (response?.sucesso) {
                    const nome = ajuste.trabalhadorDisplay || ajuste.trabalhador?.nome || 'colaborador';
                    this.NewToaster.pop({
                        type: 'success',
                        title: 'Ajuste aprovado com sucesso',
                        body: `O ajuste de ${nome} foi aprovado.`
                    });

                    this.filterReload();
                    return;
                }

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao aprovar ajuste',
                    body: 'Ocorreu um erro ao tentar aprovar o ajuste. Tente novamente.'
                });
            })
            .catch((error: any) => {
                console.error('Erro ao aprovar ajuste:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao aprovar ajuste',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar aprovar o ajuste. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }

    public recusarAjuste(ajuste: IAjustePonto): void {
        if (!ajuste?.gestaoponto) {
            console.error('Ajuste sem ID');
            return;
        }

        if (!this.podeRecusar(ajuste)) {
            return;
        }

        const modalInstance = this.MotivoRecusaModalService.open();

        modalInstance.result.then((motivo: string) => {
            this.executarRecusa(ajuste.gestaoponto, motivo);
        }).catch(() => { /* cancelado */ });
    }

    // --- Ações em lote ---

    public podeAprovarSelecionados(): boolean {
        if (this.aprovacaoLoteBusy || this.recusaLoteBusy) {
            return false;
        }

        return this.coletarIdsAprovaveisSelecionados().length > 0;
    }

    public podeRecusarSelecionados(): boolean {
        if (this.recusaLoteBusy || this.aprovacaoLoteBusy) {
            return false;
        }

        return this.coletarIdsRecusaveisSelecionados().length > 0;
    }

    public aprovarAjustesSelecionados(): void {
        const ids = this.coletarIdsAprovaveisSelecionados();

        if (!ids.length || this.aprovacaoLoteBusy || !this.podeAprovarSelecionados()) {
            return;
        }

        this.busy = true;
        this.aprovacaoLoteBusy = true;

        this.AjustesPontoService.aprovarAjustesLote(ids)
            .then((response: any) => {
                const resultados = Array.isArray(response?.resultado) ? response.resultado : [];
                const aprovados = resultados.filter((item: any) => item?.sucesso);

                if (aprovados.length) {
                    this.NewToaster.pop({
                        type: 'success',
                        title: 'Ajustes aprovados com sucesso',
                        body: `${aprovados.length} ajuste(s) aprovados.`
                    });

                    this.checkboxPreenchidos = [];
                    this.filterReload();
                    return;
                }

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao aprovar ajustes',
                    body: 'Ocorreu um erro ao tentar aprovar os ajustes. Tente novamente.'
                });
            })
            .catch((error: any) => {
                console.error('Erro ao aprovar ajustes em lote:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao aprovar ajustes',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar aprovar os ajustes. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
                this.aprovacaoLoteBusy = false;
            });
    }

    public recusarAjustesSelecionados(): void {
        const ids = this.coletarIdsRecusaveisSelecionados();

        if (!ids.length || this.recusaLoteBusy || !this.podeRecusarSelecionados()) {
            return;
        }

        const modalInstance = this.MotivoRecusaModalService.open();

        modalInstance.result.then((motivo: string) => {
            this.executarRecusaLote(ids, motivo);
        }).catch(() => { /* cancelado */ });
    }

    public selecaoComSituacoesDiferentes(): boolean {
        if (!Array.isArray(this.checkboxPreenchidos) || !this.checkboxPreenchidos.length) {
            return false;
        }

        const situacoes = this.obterSituacoesSelecionadas();
        return situacoes.size > 1;
    }

    // --- Métodos privados ---

    private baixarArquivo(arquivo: Blob): void {
        const fileURL = (window.URL || window.webkitURL).createObjectURL(arquivo);
        const link = document.createElement('a');

        document.body.appendChild(link);
        link.style.display = 'none';
        link.href = fileURL;
        link.download = this.resolveNomeArquivoExportacao();
        link.click();

        document.body.removeChild(link);
        (window.URL || window.webkitURL).revokeObjectURL(fileURL);
    }

    private resolveNomeArquivoExportacao(): string {
        const situacao = this.situacoesAjustes.find((item) => item.value === this.filters.situacao);
        const sufixo = (situacao?.label || 'pendentes').toLowerCase();

        return `ajustes-de-ponto-${sufixo}.xlsx`;
    }

    private resolveDetalhes(ajuste: IAjustePonto): void {
        const detalhes = (ajuste?.detalhes || {}) as Record<string, any>;
        // 110540: no ajuste de pausa a view entrega a hora em pausa_valor/pausaantiga_valor.
        const novo = detalhes.marcacao_valor || detalhes.pausa_valor || '';
        const antigo = detalhes.marcacaoantiga_valor || detalhes.pausaantiga_valor || '';

        ajuste.horarioLabel = '';
        ajuste.horarioAntigo = '';
        ajuste.horarioNovo = '';

        if (antigo && novo) {
            ajuste.horarioAntigo = antigo;
            ajuste.horarioNovo = novo;
        } else {
            const valor = novo || antigo;
            if (valor) {
                ajuste.horarioLabel = this.resolveMarcacaoLabel(ajuste);
                ajuste.horarioNovo = valor;
            }
        }

        if (!ajuste.justificativa && detalhes.justificativa) {
            ajuste.justificativa = detalhes.justificativa;
        }

        ajuste.detalhesMotivo = this.resolveDetalhesMotivo(ajuste, detalhes);

        if (ajuste.temAnexo === undefined || ajuste.temAnexo === null) {
            ajuste.temAnexo = Boolean(detalhes.tem_anexo);
        }

        if (detalhes.historico_status_exibicao) {
            ajuste.historicoStatusExibicao = detalhes.historico_status_exibicao;
        } else {
            ajuste.historicoStatusExibicao = this.resolveHistoricoStatusExibicao(ajuste, detalhes);
        }
    }

    private resolveDetalhesMotivo(ajuste: IAjustePonto, detalhes: Record<string, any>): string {
        const origem = `${ajuste?.origem || ''}`.toLowerCase();
        // 110093: atraso_marcacao entra aqui porque o handler do backend grava a justificativa da
        // recusa na coluna motivo de ponto.atrasosjustificadosmarcacoes, e a view expõe isso em
        // detalhes.motivo, igual ao atestado. Sem esta origem, o texto de quem recusou o abono não
        // apareceria em lugar nenhum da tela.
        if (origem !== 'atestado' && origem !== 'atestado_horas' && origem !== 'atraso_marcacao') {
            return '';
        }

        const motivo = detalhes?.motivo;
        if (motivo === null || motivo === undefined) {
            return '';
        }

        return motivo;
    }

    private resolveHistoricoStatusExibicao(ajuste: IAjustePonto, detalhes: Record<string, any>): string {
        const status = this.resolveHistoricoStatusLabel(ajuste?.status, ajuste?.statuscodigo);
        if (!status || status === AjustePontoSituacao.Pendente) {
            return '';
        }

        const responsavel = String(detalhes?.responsavel || detalhes?.responsavel_email || '').trim();
        const dataMudanca = String(detalhes?.data_mudanca_estado || '').trim();
        if (!responsavel || !dataMudanca) {
            return '';
        }

        const dataFormatada = this.resolveDataHoraStatus(dataMudanca);
        if (!dataFormatada) {
            return '';
        }

        return `${status} por ${responsavel} em ${dataFormatada}`;
    }

    private resolveHistoricoStatusLabel(status: unknown, statuscodigo: number | undefined): string {
        const resolved = this.resolveSituacaoValue(status);
        if (resolved) {
            return resolved;
        }

        switch (statuscodigo) {
            case 2:
                return AjustePontoSituacao.Aprovado;
            case 3:
                return AjustePontoSituacao.Recusado;
            case 1:
                return AjustePontoSituacao.Pendente;
            default:
                return '';
        }
    }

    private resolveDataHoraStatus(data: string): string {
        if (!data) {
            return '';
        }

        const parsed = moment.parseZone(data);
        if (!parsed.isValid()) {
            return '';
        }

        return `${parsed.format('DD/MM/YYYY')} às ${parsed.format('HH:mm')}`;
    }

    private resolveMarcacaoLabel(ajuste: IAjustePonto): string {
        const origem = `${ajuste?.origem || ''}`.toLowerCase();
        const tipo = `${ajuste?.tipo || ''}`.toLowerCase();

        // 110093: o atraso justificado age sobre uma batida existente, sem alterá-la. O rótulo
        // mostra o abono, que é a informação que distingue uma linha de atraso das demais.
        if (origem === 'atraso_marcacao') {
            const minutos = ajuste?.detalhes?.minutos_valor;
            return minutos ? `Atraso de ${minutos}` : 'Atraso justificado';
        }

        if (origem !== 'ajuste_marcacao' && origem !== 'ajuste_pausa') {
            return '';
        }

        if (tipo === 'incluir') {
            return 'Incluir';
        }
        if (tipo === 'alterar') {
            return 'Alterar';
        }
        if (tipo === 'ignorar') {
            return 'Ignorar';
        }

        return '';
    }

    private applyOrdenacao(entities: IAjustePonto[]): IAjustePonto[] {
        if (!this.ordenacao?.campo || !entities.length) {
            return entities;
        }

        const fator = this.ordenacao.direcao === 'asc' ? 1 : -1;
        const ordenados = entities.map((entity, index) => ({ entity, index }));

        ordenados.sort((itemA, itemB) => {
            const timeA = this.resolveOrdenacaoTimestamp(itemA.entity, this.ordenacao!.campo);
            const timeB = this.resolveOrdenacaoTimestamp(itemB.entity, this.ordenacao!.campo);

            if (timeA === null && timeB === null) {
                return itemA.index - itemB.index;
            }
            if (timeA === null) {
                return 1;
            }
            if (timeB === null) {
                return -1;
            }
            if (timeA === timeB) {
                return itemA.index - itemB.index;
            }
            return (timeA - timeB) * fator;
        });

        return ordenados.map((item) => item.entity);
    }

    private resolveOrdenacaoTimestamp(ajuste: IAjustePonto, campo: IAjustesPontoOrdenacao['campo']): number | null {
        if (campo === 'dataajustada') {
            return this.parseDataTimestamp(ajuste.dataajustada);
        }
        if (campo === 'data_mudanca_estado') {
            return this.parseDataTimestamp(ajuste?.detalhes?.data_mudanca_estado);
        }
        return null;
    }

    private parseDataTimestamp(data: string | null | undefined): number | null {
        if (!data) {
            return null;
        }

        if (typeof data === 'string' && /^\d{2}\/\d{2}\/\d{4}$/.test(data)) {
            const parsed = moment(data, 'DD/MM/YYYY', true);
            return parsed.isValid() ? parsed.valueOf() : null;
        }

        const parsed = moment.parseZone(data);
        return parsed.isValid() ? parsed.valueOf() : null;
    }
    private updateFieldsForSituacao(): void {
        const includeActions = this.filters?.situacao === AjustePontoSituacao.Pendente;
        this.fields = applyNsjTableInlineMobileLabels(includeActions ? [...this.baseFields, this.actionsField] : [...this.baseFields]);
    }

    private executarRecusa(ajustePontoId: string, motivo: string): void {
        this.busy = true;

        this.AjustesPontoService.recusarAjuste(ajustePontoId, motivo)
            .then((response: any) => {
                if (response?.sucesso) {
                    const ajuste = this.entityService.entities.find((entity) => entity.gestaoponto === ajustePontoId);
                    const nome = ajuste?.trabalhadorDisplay || ajuste?.trabalhador?.nome || 'colaborador';
                    this.NewToaster.pop({
                        type: 'success',
                        title: 'Ajuste recusado com sucesso',
                        body: `O ajuste de ${nome} foi recusado.`
                    });

                    this.filterReload();
                    return;
                }

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao recusar ajuste',
                    body: 'Ocorreu um erro ao tentar recusar o ajuste. Tente novamente.'
                });
            })
            .catch((error: any) => {
                console.error('Erro ao recusar ajuste:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao recusar ajuste',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar recusar o ajuste. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
            });
    }

    private executarRecusaLote(ids: string[], motivo: string): void {
        this.busy = true;
        this.recusaLoteBusy = true;

        this.AjustesPontoService.recusarAjustesLote(ids, motivo)
            .then((response: any) => {
                const resultados = Array.isArray(response?.resultado) ? response.resultado : [];
                const recusados = resultados.filter((item: any) => item?.sucesso);

                if (recusados.length) {
                    this.NewToaster.pop({
                        type: 'success',
                        title: 'Ajustes recusados com sucesso',
                        body: `${recusados.length} ajuste(s) recusados.`
                    });

                    this.checkboxPreenchidos = [];
                    this.filterReload();
                    return;
                }

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao recusar ajustes',
                    body: 'Ocorreu um erro ao tentar recusar os ajustes. Tente novamente.'
                });
            })
            .catch((error: any) => {
                console.error('Erro ao recusar ajustes em lote:', error);

                this.NewToaster.pop({
                    type: 'error',
                    title: 'Erro ao recusar ajustes',
                    body: error?.data?.message || 'Ocorreu um erro ao tentar recusar os ajustes. Tente novamente.'
                });
            })
            .finally(() => {
                this.busy = false;
                this.recusaLoteBusy = false;
            });
    }

    private resolveActiveTabIndex(situacao?: AjustePontoSituacao): number {
        if (!situacao) {
            return this.situacoesAjustes.length;
        }

        const index = this.situacoesAjustes.findIndex((item) => item.value === situacao);
        return index === -1 ? this.situacoesAjustes.length : index;
    }




    private resolveSituacaoValue(status: unknown): AjustePontoSituacao | null {
        if (!status) {
            return null;
        }

        const normalized = String(status).toLowerCase();

        if (normalized === AjustePontoSituacao.Pendente.toLowerCase()) {
            return AjustePontoSituacao.Pendente;
        }

        if (normalized === AjustePontoSituacao.Aprovado.toLowerCase()) {
            return AjustePontoSituacao.Aprovado;
        }

        if (normalized === AjustePontoSituacao.Recusado.toLowerCase()) {
            return AjustePontoSituacao.Recusado;
        }

        return null;
    }

    private isPendente(ajuste: IAjustePonto): boolean {
        const situacao = this.resolveSituacaoValue(ajuste?.status);
        return situacao ? situacao === AjustePontoSituacao.Pendente : true;
    }

    private hasSearchActive(): boolean {
        return !!this.normalizeSearchValue(this.searchTerm);
    }



    private onDestroy(): void {
        this.entities = [];
        this.checkboxPreenchidos = [];
        this.totalPendente = 0;
    }

    private coletarIdsAprovaveisSelecionados(): string[] {
        if (!Array.isArray(this.checkboxPreenchidos) || !this.checkboxPreenchidos.length) {
            return [];
        }

        const ids = this.checkboxPreenchidos
            .filter((ajuste) => this.podeAprovar(ajuste) && !!ajuste.gestaoponto)
            .map((ajuste) => ajuste.gestaoponto);

        return Array.from(new Set(ids));
    }

    private coletarIdsRecusaveisSelecionados(): string[] {
        if (!Array.isArray(this.checkboxPreenchidos) || !this.checkboxPreenchidos.length) {
            return [];
        }

        const ids = this.checkboxPreenchidos
            .filter((ajuste) => this.podeRecusar(ajuste) && !!ajuste.gestaoponto)
            .map((ajuste) => ajuste.gestaoponto);

        return Array.from(new Set(ids));
    }

    private obterSituacoesSelecionadas(): Set<string> {
        const situacoes = new Set<string>();

        if (!Array.isArray(this.checkboxPreenchidos)) {
            return situacoes;
        }

        this.checkboxPreenchidos.forEach((ajuste) => {
            const status = ajuste?.status as AjustePontoSituacao;
            const situacao = status ? this.situacaoLabels[status] : ajuste?.situacaoLabel;
            const chave = situacao || '__situacao_indefinida__';
            situacoes.add(chave);
        });

        return situacoes;
    }
}
